import { SubmissionError } from 'redux-form';
import {
  patchRequest,
  handleThrowSubmissionError
} from '../../../utilities/requests';
import { setReferralBankDetails } from './reducer';

export const handleSubmit = async (values, dispatch, props) => {
  if (props.fileUploadDirty) {
    await uploadFiles(values);
  }
  try {
    const url = '/referral_bank_details';
    const response = await patchRequest(url, values);
    dispatch(setReferralBankDetails(response.data.referral_bank_detail));
    props.setFormState('show');
  } catch (error) {
    handleThrowSubmissionError(error.response);
  }
};

const uploadFiles = async values => {
  let newData = false;
  const url = '/referral_bank_details/documents';
  const payload = new FormData();
  if (values.voided_cheque && values.voided_cheque !== true) {
    payload.append('voided_cheque', values.voided_cheque);
    newData = true;
  }
  if (newData) {
    try {
      await patchRequest(url, payload);
    } catch (error) {
      throw new SubmissionError({ _error: 'Error uploading documents' });
    }
  }
};
